<template>
  <div>
    <h2 class="title-type-1">
      매체 관리
      <v-tooltip right content-class="tooltip-custom-1">
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="ico-help-1" v-bind="attrs" v-on="on">mdi-help</v-icon>
        </template>
        <span
          >VX의 모든 광고매체를 등록/정보 수정등 관리하는 매체 등록은
          Owner계정만 가능합니다</span
        >
      </v-tooltip>
    </h2>

    <ul class="tab-type-1">
      <li v-for="header in filteredHeaders" :key="header.name">
        <router-link
          :to="{ name: header.name }"
          :class="{ active: $route.name === header.name }"
          >{{ header.text }}</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { constantUserType } from '@/utils/constant';
import _ from 'lodash';

export default {
  data: () => ({
    headers: [
      { name: 'media', text: '매체 관리' },
      { name: 'mediaCourse', text: '코스 관리' },
      { name: 'mediaCourseV2', text: '코스 관리(NEW)' },
      { name: 'mediaXml', text: '3D배너_XML관리' },
      { name: 'mediaCourseGroup', text: '그룹 CC 관리' },
      {
        name: 'mediaOption',
        text: '지면 옵션 관리',
        auths: [constantUserType.Developer],
      },
    ],
  }),
  computed: {
    filteredHeaders() {
      return this.headers.filter(header => {
        if (!header.auths) return true;

        for (const auth of header.auths) {
          if (this.$store.getters[`is${_.capitalize(auth)}`]) return true;
        }

        return false;
      });
    },
  },
};
</script>
